<template>
  <TsMedia append-class="lg:gap-6 max-lg:flex-col">
    <TsMediaContent append-class="max-lg:mb-4 lg:px-4 lg:py-8">
      <iframe
        id="yt-video-1"
        v-if="active_video.src"
        :src="active_video.src"
        class="w-full aspect-video rounded-xl mb-4"
        :title="active_video.title"
        allowfullscreen
      ></iframe>
      <div class="flex items-start justify-between gap-2">
        <div>
          <TsTypography as="h4" append-class="mb-2 line-clamp-2">
            {{ active_video.title }}
          </TsTypography>
          <TsTypography append-class="line-clamp-2" size="sm">
            {{ active_video.sub_title }}
          </TsTypography>
        </div>
        <TsButton
          variant="secondary"
          append-class="p-2"
          icon-class="size-6"
          rounded
          icon="material-symbols:share-outline"
        />
      </div>
    </TsMediaContent>
    <TsMediaEnd
      append-class="overflow-auto max-lg:ml-0 max-h-[500px] md:min-w-[300px] lg:min-w-[428px] lg:max-w-[428px]"
    >
      <div class="bg-natural-soft-white py-2 px-3 mb-6">
        <TsTypography variant="h2" append-class="mb-0"> Product Videos </TsTypography>
      </div>

      <div class="flex flex-col gap-6">
        <div
          v-for="(item, index) in props.videos"
          :key="item"
          @click="() => onVideoClick(index)"
          class="flex items-start gap-3"
        >
          <div
            :class="
              twMerge(
                'border border-2 overflow-hidden rounded-lg min-w-[150px]',
                selected_index === index && 'border-primary'
              )
            "
          >
            <TsImage
              v-if="item.thumb"
              :src="item.thumb"
              class="object-cover"
              width="150"
              height="100"
              loading="lazy"
            />
          </div>
          <div>
            <TsTypography variant="h4" append-class="line-clamp-2 mb-1">
              {{ item.title }}
            </TsTypography>
            <TsTypography size="sm" append-class="line-clamp-2">
              {{ item.sub_title }}
            </TsTypography>
          </div>
        </div>
      </div>
    </TsMediaEnd>
  </TsMedia>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";
type Props = {
  title?: string;
  videos?: object[];
};

const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);

const TsMediaEnd = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaEnd.vue')
);  

const props = withDefaults(defineProps<Props>(), {});

const selected_index = ref(0);

const active_video = computed(() => {
  if (props.videos.length === 0) return;
  return props.videos[selected_index.value];
});

const onVideoClick = (index) => {
  selected_index.value = index;
  active_video.value = props.videos[index];
};
</script>
